import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SideNavComponent } from '../side-nav/side-nav.component';
import { NotFoundComponent } from '../components/not-found/not-found.component';
import { DocumentTrackingComponent } from './document-tracking/document-tracking.component';
import { DocumentRequirementsComponent } from './document-requirements/document-requirements.component';

const routes: Routes = [
  {
    path: 'documents',
    component: SideNavComponent,
    children: [
      {
        path: 'tracking',
        component: DocumentTrackingComponent,
        pathMatch: 'full',
      },
      {
        path: 'requirements',
        component: DocumentRequirementsComponent,
        pathMatch: 'full',
      },
      {
        path: '',
        redirectTo: '/documents/tracking',
        pathMatch: 'full',
      },
      {
        path: '**',
        component: NotFoundComponent,
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DocumentTrackingRoutingModule {}
